<template>
  <div class="w-full h-full">
    <section>
      <h2 class="mx-auto my-4 px-8 text-2xl font-medium document-page-title">
        Nomina
      </h2>
      <div class="flex flex-col lg:flex-row px-8 m-auto">
        <CardComponent
          v-for="(card, index) in filterMainMenu"
          :key="`main-${index}`"
          :card="card"
          @click="redirectTo(card.to)"
          class="lg:w-2/5 lg:mr-4 mb-4 lg:mb-0"
          :cardClass="`p-8`"
        />
      </div>
    </section>

    <section v-if="true">
      <h3 class="mx-auto my-4 px-8 text-2xl font-medium document-page-title">
        {{ $t("message.documentsManagement.cards.history.title") }}
      </h3>
      <div class="flex flex-col lg:flex-row px-8 m-auto">
        <CardComponent
          v-for="(card, index) in secondaryMenu"
          :key="`secondary-${index}`"
          :card="card"
          @click="redirectTo(card.to)"
          class="lg:w-1/3 lg:mr-4 mb-4 lg:mb-0"
          data-vs-link="go-to-request-history"
        />
      </div>
    </section>
  </div>
</template>
<script>
import { mapState } from "vuex";
import CardComponent from '../components/CardComponent.vue'; 
export default {
  name: "PayrollMenu",
  components: {
    CardComponent,
  },
  data() {
    return {
      mainMenu: [
        {
          img: "SalaryAdvanceSVG",
          title: "Anticipo de sueldo",
          subtitle: this.$t("message.documentsManagement.cards.upload.subtitle"),
          action: 77,
          to: "salaryAdvances",
        },
        {
          img: "LoanSVG",
          title: "Prestamos",
          subtitle: this.$t("message.documentsManagement.cards.certificates.subtitle"),
          action: 77,
          to: "certificates",
        },
      ],
      secondaryMenu: [
        {
          icon: "search-outline",
          title: "Retenciones judicailes",
          subtitle: this.$t("message.documentsManagement.cards.upload.subtitle"),
          action: 77,
          to: "upload",
        },
        {
          icon: "search-outline",
          title: "Beneficios corporativos",
          subtitle: this.$t("message.documentsManagement.cards.certificates.subtitle"),
          action: 77,
          to: "certificates",
        },
      ],
    };
  },
  computed: {
    ...mapState(["actions"]),
    filterMainMenu() {
      return this.mainMenu.filter(this.filterActionsMenu);
    },
  },
  methods: {
    filterActionsMenu(item) {
      if (!this.actions) return false;
      if (this.actions.length > 0) {
        return this.actions.map((e) => parseInt(e.id)).includes(item.action);
      }
      return false;
    },
    redirectTo(to) {
      this.$router.push({ name: to });
    },
  },
};
</script>

<style scoped lang="scss">
h2,
h3 {
  color: #707070;
}
h3 {
  font-size: 1.25rem;
}
.full-svg {
  svg {
    width: 100%;
    height: 100%;
  }
}
</style>
